



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,X} from 'lucide-react';

  
import "../../Create/CreateCourse/WhatWillYouLearnAddMore.css";
const TargetAudienceProductAddMore=({index ,
    paragraph,id,onRemove,changeItemParagraph})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemParagraph, setItemParagraph] = useState(paragraph); 
  


    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<><div 
   
   
   style={{padding:"5px",margin:"5px", marginTop:"10px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"3px solid rgba(144, 202, 249,1)"}}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"20px",
      background:"#958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
    
 
<div  style={{}}><div style={{}}>
    
    
    </div> 
    <div>
    <div className="YoutubeVideoLinkCardInner"  > 
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"50px",height:"50px",
      borderRadius:"50%",
        float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}>
          <GripVertical color="#958FDA" size={32} />
          </div>  
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={2} value={itemParagraph} type="text"
     placeholder={(index+1)+": Add A Line About A Target Audience "}
        onChange={(e)=>{handleChange(e);changeItemParagraph(id,e.target.value);setItemParagraph(e.target.value);}}
        style={{height:"50px",minWidth:"150px",marginTop:"1px"}}  className="inputTextCard"></textarea>}</div>
   <div style={{float:"right",padding:"15px"}}>
   
   <div  className="coloredTextV1" >
        Word count: {wordCount} / 50
      </div>
    </div> 
    
     
    </div>
    
    </div>
    
    </div></>)
}  

export default TargetAudienceProductAddMore;
